import { render, staticRenderFns } from "./ContactsSearch.vue?vue&type=template&id=4f8c4506&scoped=true&"
import script from "./ContactsSearch.vue?vue&type=script&lang=js&"
export * from "./ContactsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSearch.vue?vue&type=style&index=0&id=4f8c4506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c4506",
  null
  
)

export default component.exports